import cartModule from '../scripts/cart/cart.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(cartModule);